/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

export class ExceptionEntity {

    constructor(public message?: string,
                public truncatedStackTrace?: string,
                public uuid?: string,
                public createdBy?: string,
                public createdAt?: Date,
                public systemName?: string,
                public stackTrace?: string) {
    }

}
